import _ from "underscore";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import OutsideClick from "../elements/outside-click";
import GlobalKeypress from "../elements/global-keypress";
import Utils from "../../utils/basic-utils";

export default class extends React.Component {
  static displayName = "Modal";

  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    children: PropTypes.element.isRequired,
    closeOnEscape: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
    onMount: PropTypes.func,
    onUnmount: PropTypes.func, // call when unmount is triggered
    onClose: PropTypes.func,
  };

  static defaultProps = {
    closeOnEscape: true,
    closeOnOutsideClick: true,
  };

  componentDidMount() {
    if (document.body.className) {
      document.body.className = `${document.body.className} et--modal--is-open`;
    } else {
      document.body.className = "et--modal--is-open";
    }
    return typeof this.props.onMount === "function" ? this.props.onMount() : undefined;
  }

  componentWillUnmount() {
    document.body.className = Utils.removeClassname(document.body.className, "et--modal--is-open");
    return typeof this.props.onUnmount === "function" ? this.props.onUnmount() : undefined;
  }

  handleOutsideClick = () => {
    if (this.props.closeOnOutsideClick) {
      this.handleClose();
    }
  };

  handleEscape = e => {
    if (this.props.closeOnEscape) {
      this.handleClose();
    }
  };

  handleClose = () => _.delay(() => (typeof this.props.onClose === "function" ? this.props.onClose() : undefined), 300);

  render() {
    const child = React.Children.only(this.props.children);

    return (
      <div className={classNames(this.props.className, { "et--modal": true })}>
        <GlobalKeypress onEscape={this.handleEscape} />
        <OutsideClick
          className="et--modal--overlay"
          closeOnElementClick={true}
          onOutsideClick={this.handleOutsideClick}
        >
          <div className="et--modal--dialog" style={{ width: this.props.width }}>
            {_.isFunction(child.type) ? React.cloneElement(child, { closeModal: this.handleClose }) : child}
          </div>
        </OutsideClick>
      </div>
    );
  }
}
